export enum SortDirection {
	ASCENDING = 'ASC',
	DESCENDING = 'DESC',
}
